<template>
  <textarea-input
    ref="input"
    class="text-list-input"
    :label="label"
    :errors="errors"
    :value="lines"
    :rows="rows"
    :resize="resize"
    :placeholder="placeholderStr"
    @input="onInput"
  />
</template>

<script>
import isArray from 'lodash/isArray';
import Input from '@/mixins/Input';
import TextareaInput from '@/components/TextareaInput';

const LINE_SEPARATOR = '\n';

function loadLines(value) {
  if (isArray(value)) return (value || []).join(LINE_SEPARATOR);
  return value;
}

export default {
  name: 'text-list-input',
  mixins: [Input],
  components: {
    TextareaInput,
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    placeholder: [Array, String],
    rows: {
      type: Number,
      default: 5,
    },
    resize: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      lines: loadLines(this.value),
      placeholderStr: loadLines(this.placeholder),
    };
  },
  watch: {
    value(value) {
      this.valueLines = loadLines(value);
    },
    placeholder(placeholder) {
      this.placeholderStr = loadLines(placeholder);
    },
  },
  methods: {
    onInput(value) {
      const lines = [];
      value.split(LINE_SEPARATOR).forEach((line) => {
        if (line) lines.push(line);
      });
      this.$emit('input', lines);
      this.$emit('change', lines);
      this.clearErrors();
    },
    focus() {
      this.$input.focus();
    },
    blur() {
      this.$input.blur();
    },
  },
};
</script>



// WEBPACK FOOTER //
// TextListInput.vue?510e92ec